// eslint-disable-next-line no-useless-escape
import FileSaver from 'file-saver';

export const removeExtension = (filename) => filename.replace(/\.[^\/.]+$/, '');

export const getBase64FromFile = (file: File) => new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
});

export const getFileFromBase64 = async (
    base64: string,
    name: string,
    fileType: string,
) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));

    const byteArray = new Uint8Array(byteNumbers);

    return new File([byteArray], name, { type: fileType });
};

export const saveBase64File = async ({
    base64,
    name = 'downloaded.pdf',
    fileType = 'application/pdf',
}) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });

    await FileSaver.saveAs(blob, name);
};

export function extractDecodedFilename(header: string): string | null {
    const utf8Match = header?.match(/filename\*\s*=\s*UTF-8''([^;\n]*)/);

    if (utf8Match) {
        return decodeURIComponent(utf8Match[1]);
    }

    const fallbackMatch = header?.match(/filename\s*=\s*"([^"]+)"/);

    if (fallbackMatch) {
        return fallbackMatch[1];
    }

    return null;
}

export const isImageFormat = (file) => file.type.match(/(x-png|png|jpg|jpeg)/g);
export const isPdfFormat = (file) => file.type === 'application/pdf';
